__turbopack_context__.v({
  "srOnly": "NewTabHint-module-scss-module__jfTlra__srOnly",
});
